import { ElementRef, Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({ name: 'innerHtmlPipe' })

export class InnerHTMLPipe implements PipeTransform {
  constructor(private commonService: CommonService) {       
  }
    transform(str: any, args: any): any {
        args.innerHTML =this.commonService.sanitizeInnerHtml(str);
    }
}
